import api from './api'

export const integrationService = {
  getProviders: async () => {
    const response = await api.get('/integrations/providers')
    return response.data
  },

  getIntegration: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/integrations`)
    return response.data
  },

  saveIntegration: async (projectId, data) => {
    const response = await api.put(`/projects/${projectId}/integrations`, data)
    return response.data
  },

  deleteIntegration: async (projectId) => {
    const response = await api.delete(`/projects/${projectId}/integrations`)
    return response.data
  },

  getExternalStatuses: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/integrations/statuses`)
    return response.data
  },

  getStatusMappings: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/integrations/status-mappings`)
    return response.data
  },

  saveStatusMappings: async (projectId, mappings) => {
    const response = await api.put(`/projects/${projectId}/integrations/status-mappings`, { mappings })
    return response.data
  },

  triggerSync: async (projectId) => {
    const response = await api.post(`/projects/${projectId}/integrations/sync`)
    return response.data
  },
}
